import React, { useState, useRef, useLayoutEffect } from "react";
import Layout from "../components/Layout";
import data from "../data/data.json";
import { gsap } from "gsap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

const HomePage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const photos = data.galeri;
  const sertifikat = data.sertifikat;
  const hafidz = data.hafidz;
  const pengurus = data.pengurus;

  const nextPhoto = () => {
    setCurrentIndex((currentIndex + 1) % photos.length);
  };

  const prevPhoto = () => {
    setCurrentIndex((currentIndex - 1 + photos.length) % photos.length);
  };

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const yoyo = useRef(null);

  useLayoutEffect(() => {
    gsap.to(yoyo.current, {
      duration: 2,
      yoyo: true,
      repeat: -1,
      y: 20,
      ease: "power1.inOut",
    });
  }, []);

  return (
    <Layout>
      <section id="carousel" data-aos='fade-down'>
        <div className="flex flex-col lg:flex-row gap-2 lg:p-20">
          <div className="lg:w-1/2">
            <img
              src="banner.webp"
              alt=""
              className="lg:h-[700px]"
              loading="lazy"
            />
          </div>
          <div className="lg:w-1/2 flex flex-col gap-1 lg:gap-4 font-inter lg:p-20 lg:mt-12 p-2">
            <h2 className="text-yellow-400 text-center lg:text-right text-xl md:text-4xl lg:text-5xl font-bold underline underline-offset-4">
              Rumah Tahfidz An-Nuur
            </h2>
            <h2 className="text-white text-center lg:text-right text-3xl md:text-4xl lg:text-6xl font-bold">
              Mencetak Generasi Mulia yang cinta Al-Qur'an & berakhlak mulia
            </h2>
            <p className="text-white text-center lg:text-right p-1 md:text-xl lg:text-2xl">
              Rumah Tahfidz An-Nuur didirikan pada tahun 2018 sebagai yayasan
              yang fokus memberikan kesempatan kepada Santri Penghafal Al-Qur’an
              untuk belajar, dengan program pengembangan kepemimpinan, fiqih,
              bahasa Arab, serta pelatihan berbicara di depan umum bagi para
              santri.
            </p>
          </div>
        </div>
      </section>

      <section>
        <div className="flex flex-col lg:flex-row-reverse lg:px-24">
          <div className="lg:w-1/2 p-4">
            <img src="ukhti1.webp" alt="" className="rounded-xl z-10" />
            <img
              ref={yoyo}
              src="foto1.webp"
              alt=""
              className="absolute h-40 md:h-80 rounded-xl z-20 top-[920px] md:top-[1360px] lg:top-[1350px] right-6 lg:right-32"
            />
          </div>
          <div className="text-white p-5 gap-3 flex flex-col font-inter lg:w-1/2">
            <h3 className="text-xl md:text-3xl lg:text-3xl z-40">Program Unggulan</h3>
            <h1 className="text-2xl md:text-4xl lg:text-4xl z-40 underline underline-offset-4">
              Rumah Tahfidz An-Nuur
            </h1>

            <div id="accordion">
              <button
                onClick={() => toggleAccordion(0)}
                className="font-bold py-2 md:text-xl lg:text-2xl"
              >
                Tahfidz Al-Qur’an 24 Jam {activeIndex === 0 ? "-" : "+"}
              </button>
              {activeIndex === 0 && (
                <p className="lg:text-xl" data-aos='zoom-in-up'>
                  Rumah Tahfidz An-Nuur memiliki program utama yang berfokus
                  pada kegiatan tahfidz Al-Qur’an selama 24 jam. Sebagai pusat
                  pendidikan tahfidz, tujuan utama kami adalah mengoptimalkan
                  proses menghafal Al-Qur'an bagi para santri. Awalnya, program
                  ini hanya mencakup kegiatan tahfidz murni, tetapi seiring
                  dengan perkembangan dan kebutuhan santri, kami memperkenalkan
                  berbagai program tambahan.
                </p>
              )}
              <hr className="my-4 border-white" />
            </div>

            <div>
              <button
                onClick={() => toggleAccordion(1)}
                className="font-bold py-2 md:text-xl lg:text-2xl"
              >
                Program Tambahan {activeIndex === 1 ? "-" : "+"}
              </button>
              {activeIndex === 1 && (
                <p className="lg:text-xl" data-aos='zoom-in-up'>
                  Program tambahan yang kami rancang bertujuan untuk memperkaya
                  keilmuan dan keterampilan santri, sehingga mereka memiliki
                  bekal yang cukup saat kembali ke masyarakat. Program tambahan
                  ini mencakup pelatihan jiwa kepemimpinan (leadership),
                  pendalaman bahasa Arab, serta pelajaran fiqih. Selain itu,
                  kami mengarahkan santri untuk memahami Al-Qur’an secara
                  mendalam melalui kajian tafsir, sehingga pemahaman mereka
                  lebih komprehensif.
                </p>
              )}
              <hr className="my-4 border-white" />
            </div>

            <div>
              <button
                onClick={() => toggleAccordion(2)}
                className="font-bold py-2 md:text-xl lg:text-2xl"
              >
                Pelatihan Berpidato dan Kepemimpinan{" "}
                {activeIndex === 2 ? "-" : "+"}
              </button>
              {activeIndex === 2 && (
                <p className="lg:text-xl" data-aos='zoom-in-up'>
                  Setiap minggu, kami juga melatih para santri untuk tampil di
                  depan publik dengan kegiatan berpidato, yang bertujuan
                  mengasah kepercayaan diri mereka. Untuk santri yang telah
                  menyelesaikan hafalan 30 juz, kami memberikan tanggung jawab
                  untuk berperan sebagai imam di masjid-masjid sekitar. Ketika
                  bulan Ramadhan, kami memperluas peran mereka dengan mengutus
                  santri untuk memberikan ceramah singkat (kultum) atau memimpin
                  shalat tarawih.
                </p>
              )}
              <hr className="my-4 border-white" />
            </div>

            <div>
              <button
                onClick={() => toggleAccordion(3)}
                className="font-bold py-2 md:text-xl lg:text-2xl"
              >
                Program Khusus di Bulan Ramadhan {activeIndex === 3 ? "-" : "+"}
              </button>
              {activeIndex === 3 && (
                <p className="lg:text-xl" data-aos='zoom-in-up'>
                  Selama bulan Ramadhan, aktivitas di Rumah Tahfidz sedikit
                  disesuaikan. Fokus kegiatan hafalan diberikan kelonggaran dan
                  digantikan dengan pelajaran lain yang relevan, seperti kajian
                  kitab kuning, untuk memperluas wawasan keilmuan santri. Dengan
                  demikian, program-program yang kami rancang bertujuan mencetak
                  generasi yang tidak hanya hafal Al-Qur'an, tetapi juga siap
                  menjadi pemimpin dan teladan di masyarakat.
                </p>
              )}
              <hr className="my-4 border-white" />
            </div>

            <button className="bg-yellow-500 p-4 rounded-xl font-bold">
              <a href="/Program">Lihat kegiatan santri</a>
            </button>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden">
        <div className="absolute inset-0 z-0" id="bubbles" data-aos='zoom-in-up'>
          <div className="absolute w-32 h-32 bg-cyan-300 opacity-30 rounded-full top-10 left-10 animate-pulse"></div>
          <div className="absolute w-40 h-40 bg-yellow-500 opacity-20 rounded-full top-20 right-12 animate-pulse"></div>
          <div className="absolute w-28 h-28 bg-green-400 opacity-25 rounded-full bottom-10 left-20 animate-pulse"></div>
          <div className="absolute w-36 h-36 bg-pink-400 opacity-15 rounded-full bottom-16 right-24 animate-pulse"></div>
        </div>

        <div className="relative z-10 flex flex-col gap-2 px-4 py-2 lg:py-12 lg:px-48 font-inter text-white">
          <h1 className="font-bold text-center text-3xl md:text-4xl lg:text-6xl">Galeri</h1>
          <p className="md:text-xl text-center">
            Tangkapan momen penuh inspirasi dan kebersamaan santri Rumah Tahfidz
            An-Nuur menanti Anda. Temukan cerita di balik setiap aktivitas, dari
            prestasi hingga momen kebersamaan yang penuh makna. Klik untuk
            menjelajahi lebih banyak!
          </p>
        </div>

        <div className="relative z-10 flex flex-col items-center">
          <div className="relative w-full max-w-lg lg:max-w-screen-lg h-64 lg:h-[600px] overflow-hidden">
            <img
              src={photos[currentIndex].url}
              alt={`Slide ${currentIndex + 1}`}
              className="w-full h-full object-cover rounded-lg transition-all duration-500 ease-in-out"
              style={{
                transform: `rotate(${photos[currentIndex].rotate}deg)`,
                transitionDuration: `${photos[currentIndex].speed}s`,
              }}
            />

            <button
              onClick={prevPhoto}
              className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-1 rounded-r-lg hover:bg-gray-700"
            >
              <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon>
            </button>

            <button
              onClick={nextPhoto}
              className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-1 rounded-l-lg hover:bg-gray-700"
            >
              <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon>
            </button>
          </div>

          <div className="flex space-x-2 mt-4 overflow-x-hidden">
            {photos.map((_, index) => (
              <span
                key={index}
                className={`h-2 w-2 rounded-full ${
                  currentIndex === index ? "bg-gray-800" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="relative h-[450px] overflow-hidden my-4">
        <div
          className="relative w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: "url('foto1.webp')",
            backgroundAttachment: "fixed",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-75 flex flex-col items-center justify-center text-white font-inter p-4 lg:px-48 gap-2">
            <h1 className="text-2xl md:text-3xl lg:text-4xl text-center font-bold">
              Berikan Dukungan Anda untuk Masa Depan Hafizh Qur'an!
            </h1>
            <p className="text-center md:text-xl lg:text-3xl">
              "Perumpamaan (nafkah yang dikeluarkan oleh) orang-orang yang
              menafkahkan hartanya di jalan Allah adalah serupa dengan sebutir
              biji yang menumbuhkan tujuh tangkai; pada tiap-tiap tangkai itu
              terdapat seratus biji. Allah melipatgandakan (ganjaran) bagi siapa
              yang Dia kehendaki. Dan Allah Maha Luas (karunia-Nya) lagi Maha
              Mengetahui." (Surah Al-Baqarah: 261)
            </p>
            <div className="my-2">
              <button className="bg-yellow-500 p-4 rounded-xl font-bold">
                <a href="/Donasi">Ikut Berdonasi🌟</a>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section id="hafidz">
        <div className="p-4 lg:px-48 text-white flex flex-col gap-2">
        <h1 className="text-xl lg:text-4xl font-bold text-center">Nama-nama Santri yang telah menyelesaikan hafalan Al-Qur'an 30 Juz</h1>
          <div className="flex flex-col gap-3 p-6 rounded-md shadow-2xl">
            {hafidz.map((hafidz, index) => (
              <div key={hafidz.id} className="md:text-xl font-bold text-yellow-700 p-4 px-6 md:px-16 lg:px-20" data-aos='zoom-in-right' style={{
                backgroundImage: "url('/label-153093_1280.webp')",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}>
                {`${index + 1}. ${hafidz.nama} (${hafidz.asal})`}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="pengurus">
        <div className="p-8 text-white">
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:px-40">
            {pengurus.map((person, index) => (
              <div
                key={person.id}
                className={`flex flex-col items-center p-4 rounded-lg shadow-xl ${
                  index === 2 ? "col-span-2 sm:col-span-1" : ""
                }`}
                data-aos='fade-up'
              >
                <img
                  src={person.img}
                  alt={person.nama}
                  className="w-32 h-32 rounded-full object-cover mb-4"
                />
                <p className="text-lg md:text-xl font-medium">{person.jabatan}</p>
                <p className="text-center">{person.nama}</p>
              </div>
            ))}
          </div>

          <div className="lg:px-40">
            <div className="mt-8 p-4 rounded-lg shadow-xl">
              <h2 className="text-xl md:text-2xl font-bold mb-4 text-white">
                Sertifikasi Pengajar
              </h2>
              {sertifikat.length > 0 ? (
                <div className="flex justify-center item-center gap-4" data-aos='fade-right'>
                  {sertifikat.map((item) => (
                    <div
                      key={item.id}
                      className="overflow-hidden shadow-md max-w-xs w-full"
                    >
                      <img
                        src={process.env.PUBLIC_URL + "/" + item.gambar}
                        alt={`Sertifikat ${item.id}`}
                        className="w-full h-auto"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-600">
                  Belum ada sertifikat yang ditampilkan.
                </p>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="p-4 md:p-8 lg:px-48">
        <div className="flex flex-col gap-2 lg:gap-5 p-4 lg:p-10 text-white border-1 rounded-xl bg-blur shadow-2xl" data-aos='zoom-in-up'>
          <h1 className="text-center text-2xl md:text-2xl lg:text-4xl font-bold">
            Informasi Pendaftaran
          </h1>
          <p className="md:text-xl lg:text-2xl">
            Jadilah bagian dari keluarga besar Rumah Tahfidz An-Nuur dan
            tumbuhkan kecintaan pada Al-Qur'an. Nikmati lingkungan belajar yang
            nyaman dan program unggulan untuk mengembangkan potensi santri.
            Jangan lewatkan kesempatan emas ini!
          </p>
          <p className="md:text-xl lg:text-2xl">
            Klik tombol di bawah untuk mendaftar dan mulailah perjalanan
            spiritual Anda bersama kami.
          </p>
          <button className="bg-yellow-500 p-4 rounded-xl font-bold">
            <a href="/Daftar">Daftar Sekarang!📝</a>
          </button>
        </div>
      </section>
    </Layout>
  );
};

export default HomePage;
